module.exports = __webpack_public_path__ + "img/27_65.2c14db4c.png";